<template>
  <DDataTable
    :value="data"
    v-model:filters="filters"
    selectionMode="single"
    class="w-full"
    :rows="10"
    :paginator="data.length > 10">
    <template #empty>
      <div class="my-4 flex items-center justify-center text-xl font-semibold text-gray-400">No led found.</div>
    </template>
    <template #loading> Loading led data. Please wait. </template>

    <Column field="brand" header="Brand">
      <template #body="{ data }">
        {{ data.brand?.name }}
      </template>
    </Column>
    <Column field="name" header="Name"></Column>
    <Column field="lumens" header="Lumens">
      <template #body="{ data }">
        {{ data.lumens }}
      </template>
    </Column>
    <Column field="resolution_width" header="Resolution Width"></Column>
    <Column field="resolution_height" header="Resolution Height"></Column>

    <Column field="panel_width_mm" header="Tile Width"></Column>
    <Column field="panel_height_mm" header="Tile Height"></Column>
    <Column field="brightness_nits" header="Brightness"></Column>
    <!-- <Column v-if="showEdit" style="width: 3rem">
      <template #body="slotProps">
        <DButton type="button" icon="pi pi-pencil" text rounded @click="emit('edit', slotProps.data)"></DButton>
      </template>
    </Column> -->
    <Column style="width: 3rem">
      <template #body="slotProps">
        <DButton
          type="button"
          :icon="mode === 'swap' ? 'pi pi-sync' : 'pi pi-plus'"
          text
          rounded
          @click="emit('select', slotProps.data)"></DButton>
      </template>
    </Column>
  </DDataTable>
</template>
<script setup>
import { DButton, DDataTable } from '@disguise/cloud-ui';
import { FilterMatchMode } from '@primevue/core';
import Column from 'primevue/column';
import { ref } from 'vue';

defineProps({
  data: {
    type: Array,
    required: true,
  },
  mode: {
    type: String,
    required: true,
  },
  showEdit: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select', 'edit']);
const filters = ref({
  lumens: { value: null, matchMode: FilterMatchMode.EQUALS },
});
</script>
